<template>
    <DCard
        padding
    >
        <Form
            :errors="props.errors"
            :currency-codes="props.currencyCodes"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/Countries/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    errors: {
        type: Object,
        default: () => ({})
    },
    currencyCodes: {
        type: Array,
        default: () => []
    }
})

const submitData = (form) => {
    form.post(route('settings.countries.store'))
}
</script>
